export default __webpack_public_path__ + "static/media/Ramiel2.68128403.png";